import AutocompleteDropdownComponent from './Components/AutocompleteDropdownComponent'
import BackComponent from './Components/BackComponent'
import CancelComponent from './Components/CancelComponent'
import CardComponent from './Components/CardComponent'
import CheckboxListComponent from './Components/CheckboxListComponent'
import DateTimePickerComponent from './Components/DateTimePickerComponent'
import DependantComponent from './Components/DependantComponent'
import DisabledComponent from './Components/DisabledComponent'
import DropdownComponent from './Components/DropdownComponent'
import DynamicDropdownComponent from './Components/DynamicDropdownComponent'
import HeadersComponent from './Components/HeadersComponent'
import HyperlinkComponent from './Components/HyperlinkComponent'
import IconComponent from './Components/IconComponent'
import InputComponent from './Components/InputComponent'
import LabelComponent from './Components/LabelComponent'
import LinkButtonComponent from './Components/LinkButtonComponent'
import ListComponent from './Components/ListComponent'
import MultiAutocompleteComponent from './Components/MultiAutocomplete'
import MultiLineInputComponent from './Components/MultiLineInputComponent'
import NextComponent from './Components/NextComponent'
import ProductInfoComponent from './Components/ProductInfoComponent'
import PromptComponent from './Components/PromptComponent'
import RadioButtonComponent from './Components/RadioButtonComponent'
import SaveComponent from './Components/SaveComponent'
import SemanticBoxComponent from './Components/SemanticBoxComponent'
import SummaryComponent from './Components/SummaryComponent'
import TextComponent from './Components/TextComponent'
import TitleComponent from './Components/TitleComponent'
import UploadComponent from './Components/UploadComponent'

const components = {
  title: TitleComponent,
  card: CardComponent,
  next: NextComponent,
  dropdown: DropdownComponent,
  text: TextComponent,
  hyperlink: HyperlinkComponent,
  link_button: LinkButtonComponent,
  input: InputComponent,
  cancel: CancelComponent,
  back: BackComponent,
  icon: IconComponent,
  multi_line_input: MultiLineInputComponent,
  upload: UploadComponent,
  radiobutton: RadioButtonComponent,
  productInfo: ProductInfoComponent,
  semanticBox: SemanticBoxComponent,
  dependant: DependantComponent,
  label: LabelComponent,
  disabled: DisabledComponent,
  checkboxList: CheckboxListComponent,
  dateTimePicker: DateTimePickerComponent,
  summary: SummaryComponent,
  headers: HeadersComponent,
  autocompleteDropdown: AutocompleteDropdownComponent,
  multiAutocomplete: MultiAutocompleteComponent,
  list: ListComponent,
  prompt: PromptComponent,
  save: SaveComponent,
  dynamicDropdown: DynamicDropdownComponent
}

// This is a function so it can be mocked.
export default function getAvailableComponents() {
  return components
}
